import { Avatar, Box, Chip, Link, ListItem, ListItemAvatar, styled, Typography } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import EmailIcon from '@mui/icons-material/Email';
import Button from "../../components/button/Button";
import FmdGoodIcon from '@mui/icons-material/FmdGood';

export const ManageButton = styled(Button)(() => ({
    padding: '1px 8px',
}));

export const ViewAllButton = styled<any>(Link)(() => ({
    fontWeight: 600,
    textDecoration: 'none',
    fontSize: '14px'
}));

export const StyledGroupAvatar = styled(Avatar)(() => ({
    width: '24px',
    height: '24px',
    fontSize: '12px',
    backgroundColor: '#CEE1FC80',
    color: '#006FE5',
}));

export const StyledOpenInNewIcon = styled(OpenInNewIcon)(({ theme }) => ({
    fontSize: '18px',
    color: theme.palette.primary.main,
}));

export const StyledListItemAvatar = styled(ListItemAvatar)(() => ({
    minWidth: '24px',
    marginRight: '13px',
}));

export const StyledAccountSocialBox = styled(Box)(({ theme }) => ({
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F5F6FA',
    marginBottom: theme.spacing(2),

    '& img': {
        maxWidth: '100px'
    }
}));

export const StyledAccountListContent = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: '8px',
}));

export const StyledAccountList = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
}));

export const StyledWidgetText = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    maxWidth: '200px',
}));

export const StyledPasswordBox = styled(Typography)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

export const StyledEmailBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
}));

export const StyledActiveSessionsBox = styled(Box)(({theme}) => ({
    width: '144px',
    height: '144px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    position: 'relative',
    backgroundColor: '#FAFAFC',
    margin: '15px',
    '&:before': {
        content: '""',
        width: '174px',
        height: '174px',
        borderRadius: '50%',
        border: `1px dashed #E1E3EB`,
        position: 'absolute',
        background: 'transparent',
    }
}));

export const StyledActiveNumber = styled(Typography)(({theme}) => ({
    fontSize: '60px',
    fontWeight: 600,
    color: theme.palette.primary.main,
    lineHeight: '64px',
}));

export const StyledPersonalPassHeader = styled(Typography)(() => ({
    fontFamily: 'MuseoSans',
    fontWeight: 600,
    marginBottom: '10px',
    marginTop: '10px'
}));

export const StyledImage = styled('img')(() => ({}));

export const UserNameHeader = styled(Typography)(() => ({
    fontSize: '30px',
    fontWeight: 600,
}));

export const StyledEmailIcon = styled(EmailIcon)(() => ({
    fontSize: '18px',
    color: '#ACAFBF'
}));

export const StyledPlaceIcon = styled(FmdGoodIcon)(() => ({
    fontSize: '18px',
    color: '#ACAFBF'
}));

export const cardContentStyles = { paddingTop: '0px', paddingLeft: '24px', paddingRight: '24px' };
export const cardHeaderStyles = { paddingLeft: '24px', paddingRight: '24px', paddingTop: '24px' };

export const UserAvatar = styled(Avatar)(() => ({ width: '90px', height: '90px' }));
export const deviceGridActiveStyles = { alignSelf: 'center'};
export const deviceListStyles = { width: '100%', p: 0 };
export const deviceListItemStyles = { display: 'list-item', padding: 0 };
export const deviceGridSessionItemStyles = { display: 'flex', flexWrap: 'nowrap' };
export const deviceListItemSessionText = { color: '#111111' };
export const deviceSessionBrowserInfoStyles = { marginRight: '20px', display: 'inline' };
export const deviceListItemDateStyles = {textAlign: { xs: 'left', md: 'right' }, marginTop: 0.5, color: '#474A59'};
export const widgetCardContentStyles = { paddingTop: '0px', paddingLeft: '24px', paddingRight: '24px' };
export const widgetCardHeaderStyles = { paddingLeft: '24px', paddingRight: '24px', paddingTop: '20px' };
export const groupListStyles = { width: '100%', p: 0 };
export const signinBoxStyles = { display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '8px' };
export const userInfoGridContainerStyles = { marginBottom: '35px' };
export const userInfoGridStyles = { display: 'flex', alignItems: 'center' };
export const userInfoBoxStyles = { display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5 };
export const dashboardModalBoxStyles = { padding: { xs: '15px 20px 15px', sm: '34px 34px 34px' }, textAlign: 'center' };
export const dashboardModalImgStyles = { width: { sm: '100%' } };
export const dashboardModalButtonStyles = { width: { xs: '100%', sm: 'auto' } };
export const signinUserEmailStyles = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '195px'};
